const {
  GET_ALL_CLIENT_REQUEST,
  GET_ALL_CLIENT_SUCCESS,
  GET_ALL_CLIENT_FAIL,
  ADD_CLIENT_REQUEST,
  ADD_CLIENT_SUCCESS,
  ADD_CLIENT_FAIL,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAIL,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAIL
} = require("../../actionTypes/Paramaetrage/Client");

function getAllClients(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_CLIENT_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_CLIENT_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_CLIENT_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addClient(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_CLIENT_REQUEST:
      return { loading: true, data: {} };
    case ADD_CLIENT_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_CLIENT_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateClient(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_CLIENT_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_CLIENT_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_CLIENT_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteClient(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_CLIENT_REQUEST:
      return { loading: true, data: {} };
    case DELETE_CLIENT_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_CLIENT_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export { addClient, updateClient, deleteClient, getAllClients };
